export class Advertisement {
         
    ServicePlanDetailsID: string;
    CompanyID: string;
    StartDate: Date;
    EndDate: Date;
    BannerImageUrl: string;
    AdvertisementTitle: string;
    SubTotal: number;
    Tax: number;
    Total: number;
    TimeOfclicks?: number;
    OrderID: string;
}
